import map from "lodash/fp/map";
import random from "lodash/fp/random";
import flow from "lodash/fp/flow";
import isNil from "lodash/fp/isNil";
import { isObject } from "angular-ui-router";

class Controller {
  constructor(Events, $injector, $mdDialog) {
    "ngInject";
    this.selected = [];
    this.Events = Events;
    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.enableEdit = false;
  }

  $onInit() {
    this.typeListDisplay = this.typeList.map((t) => t.display);

    const getUniqueIndex = () => random(1, 50000);

    const markDisabled = (item) => {
      if (isNil(item.isDisabled)) {
        item.isDisabled = true;
      }
      return item;
    };
    const addIndex = (item) => {
      item.index = getUniqueIndex() + getUniqueIndex();

      return item;
    };

    const initType = (item) => {
      item.type = isObject(item.type) ? item.type.name : item.type;
      return item;
    };

    this.items = flow([map(markDisabled), map(addIndex), map(initType)])(
      this.items
    );

    this.removeItem = (index, item) => {
      const confirm = this.$mdDialog
        .confirm()
        .title(
          "Are you sure about removing this ride late supply deduction plan?"
        )
        .textContent("")
        .ariaLabel("remove ride late deduction")
        .ok("Yes")
        .cancel("No");

      this.$mdDialog.show(confirm).then(
        () => {
          if (item) {
            const options = { title: this.title };
            options[this.name] = this.items;
            this.items.splice(index, 1);
          } else {
            this.items.splice(index, 1);
          }
          this.updateEvent(this.items);
        },
        () => {
          return false;
        }
      );
    };

    this.justRemove = (index) => {
      this.items.splice(index, 1);
    };

    this.confirmItem = (index, item) => {
      if (item && item.type) {
        const options = { title: this.title };
        options[this.name] = this.items;
        this.items[index].isDisabled = true;
      }
    };

    this.editItem = (index) => {
      this.items[index].isDisabled = false;
    };

    this.addItem = () => {
      this.items.push({
        isDisabled: false,
        type: "",
        amount: "",
        threshold: "",
        index: getUniqueIndex(),
      });
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/listObjects/listObjects.controller.js